<template>
  <div class="poster-image" :style="{ paddingBottom: ratioPadding }">
    <img v-if="imageSrc" :src="imageSrc" alt="poster" class="poster-image__img" />
  </div>
</template>

<script>
import imageCache from "@/utils/imageCache";

export default {
  props: {
    view: { type: String, required: true },          // l, c, m
    posterName: { type: String, required: true },     // имя картинки
    rect: { type: Object, default: null },            // координаты обрезки
    eventId: { type: [String, Number], required: true },
    forceMobileDev: { type: Boolean, default: false }, // принудительно мобильное устройство
  },
  data() {
    return {
      dev: this.forceMobileDev || (this.view === 'l' ? window.innerWidth < 640 : window.innerWidth < 1025) ? 'm' : 'd',
      ratioPadding: '52.5%', // значение по умолчанию
      imageSrc: null,
    };
  },
  mounted() {
    this.loadConfig();
  },
  methods: {
    async loadConfig() {
      try {
        const response = await fetch('/config.json');
        const config = await response.json();

        const ratioKey = `${this.dev}${this.view}Ratio`;
        const ratio = config[ratioKey];

        if (ratio) {
          this.ratioPadding = `${(1 / ratio) * 100}%`;
        }

        this.processImage();
      } catch (error) {
        console.error('Ошибка загрузки конфигурации:', error);
      }
    },

    processImage() {

      const rectKey = this.rect
        ? `x${this.rect.x}_y${this.rect.y}_w${this.rect.w}_h${this.rect.h}`
        : 'full';

      const cacheKey = `${this.posterName}_${this.dev}_${this.view}_${rectKey}`;

      if (imageCache[cacheKey]) {
        this.imageSrc = imageCache[cacheKey];
        return;
      }

      const imagePath = `/api/pis/v1/images/posters/${this.posterName}`;

      if (!this.rect) {
        imageCache[cacheKey] = imagePath;
        this.imageSrc = imagePath;
        return;
      }

      const { x, y, w, h } = this.rect;
      const originalImage = new Image();
      originalImage.crossOrigin = "Anonymous";
      originalImage.src = imagePath;

      originalImage.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = w;
        canvas.height = h;
        const ctx = canvas.getContext('2d');

        ctx.drawImage(originalImage, x, y, w, h, 0, 0, w, h);

        const finalImage = canvas.toDataURL();
        imageCache[cacheKey] = finalImage;
        this.imageSrc = finalImage;
      };

      originalImage.onerror = () => {
        console.error('Ошибка загрузки изображения:', imagePath);
      };
    }

  },
};
</script>

<style scoped>
.poster-image {
  position: relative;
  width: 100%;
  height: 0;
  overflow: hidden;
}

.poster-image__img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  /* height: 100%; */
  object-fit: contain;
}
</style>
